"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'BaseSearchForm',
  props: {
    // 表单字段配置
    formItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    // 表单数据
    formData: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    // 是否内联表单
    inline: {
      type: Boolean,
      default: true
    },
    // 表单大小
    size: {
      type: String,
      default: 'small',
      validator: function validator(value) {
        return ['large', 'medium', 'small', 'mini'].includes(value);
      }
    },
    // 标签位置
    labelPosition: {
      type: String,
      default: 'right',
      validator: function validator(value) {
        return ['left', 'right', 'top'].includes(value);
      }
    },
    // 是否显示按钮
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      validateProps: this.formData
    };
  },
  watch: {
    formData: {
      handler: function handler(val) {
        this.validateProps = val;
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    // 获取所有可重置的字段
    resettableFields: function resettableFields() {
      return this.formItems.map(function (item) {
        return item.prop;
      });
    }
  },
  methods: {
    // 搜索方法
    handleSearch: function handleSearch() {
      // 处理表单数据，特别是日期类型
      var processedData = JSON.parse(JSON.stringify(this.validateProps));

      // 遍历所有字段，处理日期类型
      this.formItems.forEach(function (item) {
        if (item.type === 'date' && processedData[item.prop] !== null && processedData[item.prop] !== undefined) {
          // 如果是日期范围数组，转换为逗号分隔的字符串
          if (Array.isArray(processedData[item.prop])) {
            processedData.dateLimit = processedData.dateLimitAttr.join(',');
          }
        }
      });
      this.$emit('search', processedData);
    },
    // 重置方法
    handleReset: function handleReset() {
      var _this = this;
      // 重置所有字段
      this.resettableFields.forEach(function (prop) {
        var item = _this.formItems.find(function (i) {
          return i.prop === prop;
        });
        if (item) {
          // 根据字段类型设置默认值
          if (item.type === 'select' || item.type === 'cascader') {
            _this.$set(_this.validateProps, prop, item.defaultValue || '');
          } else if (item.type === 'date') {
            _this.$set(_this.validateProps, 'dateLimit', '');
            _this.$set(_this.validateProps, prop, item.defaultValue || []);
          } else if (item.type === 'user') {
            //用户搜索
            _this.$set(_this.validateProps, 'searchType', 'all');
            _this.$set(_this.validateProps, 'content', '');
          } else {
            _this.$set(_this.validateProps, prop, item.defaultValue || '');
          }
        }
      });
      // 触发重置事件
      this.$emit('reset', _objectSpread({}, this.validateProps));

      // 重置后自动搜索
      // this.handleSearch();
    }
  }
};